module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel",
    on: {
      "mouseover": _vm.stopSlider,
      "touchstart": _vm.stopSlider,
      "touchend": _vm.startSlider,
      "mouseout": _vm.startSlider
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [(item.img) ? _c('a', {
      staticClass: "banner",
      style: (("background-image: url('" + (item.img) + "')")),
      attrs: {
        "href": item.href
      }
    }) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c376193c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/swimSlider.vue
// module id = 167
// module chunks = 25